/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_A4Inputs */

const en_formatter_faq_a4 = /** @type {(inputs: Formatter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no hard limit. PureJSON can format large JSON files quickly, limited only by your browser's available memory.`)
};

const ko_formatter_faq_a4 = /** @type {(inputs: Formatter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고정된 제한은 없습니다. PureJSON은 브라우저의 가용 메모리에 의해서만 제한되며, 대용량 JSON 파일도 빠르게 포맷할 수 있습니다.`)
};

const ja_formatter_faq_a4 = /** @type {(inputs: Formatter_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`厳密な制限はありません。PureJSONはブラウザの利用可能なメモリのみに制限され、大きなJSONファイルを素早くフォーマットできます。`)
};

/**
* | output |
* | --- |
* | "There is no hard limit. PureJSON can format large JSON files quickly, limited only by your browser's available memory." |
*
* @param {Formatter_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_a4 = /** @type {((inputs?: Formatter_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_a4(inputs)
	if (locale === "ko") return ko_formatter_faq_a4(inputs)
	return ja_formatter_faq_a4(inputs)
});